import './style.css'
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'

import GUI from 'lil-gui'



//brand

var brands = [
  {
    name: 'start',
    phi: 1.5707963267948966,
    theta: 0,
    x: 0,
    y: 0,
    zoom: 1.4
  },
  {
    name: 'dp',
    phi: 1.2315043202072,
    theta: 0.402123859659494,
    x: 0.0344,
    y: 0.0676,
    zoom: 0.2868
  },
  {
    name: 'vrk',
    phi: 1.13,
    theta: 0,
    x: -0.0002,
    y: 0.089,
    zoom: 0.2724
  },
  {
    name: 'jaquemus',
    phi: .99,
    theta: -0.263893782901543,
    x: -0.0512,
    y: 0.05,
    zoom: 0.336
  },
  {
    name: 'cma cgm',
    phi: 0.60318578948924,
    theta: 0,
    x: 0.0578,
    y: 0.1,
    zoom: 0.3432
  },
  {
    name: 'shark',
    phi: 0.364424747816416,
    theta: -0.282743338823081,
    x: -0.0598,
    y: 0.1098,
    zoom: 0.306
  },
  {
    name: 'jott',
    phi: 1.5707963267948966,
    theta: -1.77814144193182,
    x: 0,
    y: 0.0693,
    zoom: 0.39
  },
  {
    name: 'gertrude',
    phi: 1.5707963267948966,
    theta: 1.784424627239,
    x: -0.008,
    y: 0.0618,
    zoom: 0.552
  },
  {
    name: 'NR',
    phi: 0.615752160103599,
    theta: 2.7708847204662,
    x: -0.0932,
    y: 0.0618,
    zoom: 0.2736
  },
  {
    name: 'MDLR',
    phi: 1.37601758227233,
    theta: 3.14159265358979,
    x: 0,
    y: 0.1086,
    zoom: 0.3
  },
  {
    name: 'temps',
    phi: 0.60946897479642,
    theta: 2.95309709437441,
    x: 0.0578,
    y: 0.0516,
    zoom: 0.3468
  },
  {
    name: 'kaporal',
    phi: 2.0608847807549,
    theta: -3.14159265358979,
    x: 0,
    y: -0.0006,
    zoom: 0.3468
  },
  {
    name: 'LC ',
    phi: 1.5707963267948966,
    theta: -3.141592653589793,
    x: 0,
    y: -0.0564,
    zoom: 0.3384
  },
  {
    name: 'Z5',
    phi: 1.5707963267948966,
    theta: -3.141592653589793,
    x: 0,
    y: -0.0858,
    zoom: 0.2712
  }

]

// Tools
const lerp = (x, y, a) => x * (1 - a) + y * a;
const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));
const invlerp = (x, y, a) => clamp((a - x) / (y - x));
const range = (x1, y1, x2, y2, a) => lerp(x2, y2, invlerp(x1, y1, a));


var camPos = {
  phi: Math.PI / 2,
  theta: 0,
  x: 0,
  y: 0,
  zoom: 1.4
}

var brandPos = {
  phi: Math.PI / 2,
  theta: 0,
  x: 0,
  y: 0,
  zoom: 1.4
}

const gui = new GUI()

gui.add(brandPos, 'phi', -Math.PI, Math.PI).listen()
gui.add(brandPos, 'theta', -Math.PI, Math.PI).listen()
gui.add(brandPos, 'x', -.1, .1).listen()
gui.add(brandPos, 'y', -.15, .15).listen()
gui.add(brandPos, 'zoom', .2, 1.4).listen()

//gui.close()
gui.hide()


/**
 * brands
 */

var nBrand = 0


document.body.onkeyup = function (e) {

  if (e.key == " " ||
    e.code == "Space" ||
    e.keyCode == 32
  ) {
    console.log(`
        {
    name: ' ',
    phi: ${brandPos.phi},
    theta: ${brandPos.theta},
    x: ${brandPos.x},
    y: ${brandPos.y},
    zoom: ${brandPos.zoom}
  }
      `)
  }
}


/**
 * Sizes
 */


var sizes;

if(window.innerWidth<window.innerHeight){
  sizes = {
    width: window.innerWidth,
    height: window.innerWidth / 900 * 1500
  }
  
}else{
  sizes = {
    width: window.innerWidth,
    height: window.innerHeight
  }
  
}



window.addEventListener('resize', () => {
  // Update sizes
  if(window.innerWidth<window.innerHeight){
    sizes = {
      width: window.innerWidth,
      height: window.innerWidth / 900 * 1500
    }
    
  }else{
    sizes = {
      width: window.innerWidth,
      height: window.innerHeight
    }
    
  }
  

  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()

  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


})

// init

const camera = new THREE.PerspectiveCamera(16, sizes.width / sizes.height, 0.01, 10);


const scene = new THREE.Scene();
let GLBloader = new GLTFLoader();

var objet;

const updateAllMaterials = () =>
  {
      scene.traverse((child) =>
      {
          if(child.isMesh&& child.material.type=="MeshStandardMaterial")
          {
            if(child.material.map!==null){
              //console.log(child.material.map)
              child.material.map.colorSpace = THREE.SRGBColorSpace
            }

            
          }
      })
  }


// Ambient light
const ambientLight = new THREE.AmbientLight(0xffffff, 2.2)
scene.add(ambientLight)


//texture loader

const textureLoader = new THREE.TextureLoader();

const materialBkg = new THREE.MeshStandardMaterial({ map: textureLoader.load('img/bkg_dark.jpg'), side: THREE.DoubleSide })

materialBkg.map.colorSpace = THREE.SRGBColorSpace
materialBkg.map.repeat.set(1, 1);


GLBloader.load('objects/maillot7.glb', function (gltf) {

  var n = 0;

  gltf.scene.traverse(function (child) {

    //console.log(child.children)

  })

  objet = gltf.scene

  scene.add(objet);

  updateAllMaterials()

  objet.scale.set(.4, .4, .4)
  objet.position.y = -.5
  renderer.setAnimationLoop(animate);
  document.querySelector('canvas').classList.add('show')
})




const geometry = new THREE.SphereGeometry(1.4, 32, 32);
const sphere = new THREE.Mesh(geometry, materialBkg);
scene.add(sphere);

///

const renderer = new THREE.WebGLRenderer({ antialias: true });

renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.colorSpace = THREE.SRGBColorSpace



document.body.appendChild(renderer.domElement);



// animation

var time = 0
var target = new THREE.Vector3(0, 0, 0)
var speed = .04

function animate() {

  time += .01

  sphere.rotation.y -= .0005
  scene.rotation.y = Math.sin(time) / (range(.2, 1.4, 20, 10, camPos.zoom))
  scene.rotation.x = Math.sin(time + 10) / (range(.2, 1.4, 20, 10, camPos.zoom))



  camPos.phi = lerp(camPos.phi, brandPos.phi, speed)
  camPos.theta = lerp(camPos.theta, brandPos.theta, speed)
  camPos.x = lerp(camPos.x, brandPos.x, speed)
  camPos.y = lerp(camPos.y, brandPos.y, speed)
  camPos.zoom = lerp(camPos.zoom, brandPos.zoom, speed)


  camera.position.setFromSphericalCoords(camPos.zoom, camPos.phi, camPos.theta)
  camera.lookAt(new THREE.Vector3(camPos.x, camPos.y, 0))
  renderer.render(scene, camera);

}

const gotoBrand = () => {

  //console.log(brands[nBrand].name)

  brandPos.phi = brands[nBrand].phi
  brandPos.theta = brands[nBrand].theta
  brandPos.x = brands[nBrand].x
  brandPos.y = brands[nBrand].y
  brandPos.zoom = brands[nBrand].zoom

  readyToSwipe = false
  document.querySelector('.overlay').classList.add('off')
  document.querySelector('.control').classList.remove('off')

  if (nBrand != 0) {
    document.querySelector('.brand-title').classList.add('off')
  } else {
    document.querySelector('.brand-title').classList.remove('off')
  }
}


document.querySelector('.arrow-right').addEventListener('click', () => {

  nBrand++
  nBrand %= brands.length
  gotoBrand()


})


document.querySelector('.arrow-left').addEventListener('click', () => {

  nBrand += brands.length - 1
  nBrand %= brands.length
  gotoBrand()


})

document.querySelector('.all_brand').addEventListener('click', () => {

  nBrand = 0
  gotoBrand()
  document.querySelector('.overlay').classList.remove('off')
  document.querySelector('.control').classList.add('off')

})

//swiper

var xStart;
var readyToSwipe = true

document.querySelector('.main').addEventListener('touchstart', (e) => {
  xStart = e.touches[0].pageX
  readyToSwipe = true
})

document.querySelector('.main').addEventListener('touchmove', (e) => {


  if (xStart - e.touches[0].pageX > 16 && readyToSwipe&&nBrand!=0) {
    nBrand++
    nBrand %= brands.length
    gotoBrand()
  }


  if (xStart - e.touches[0].pageX < -16 && readyToSwipe&&nBrand!=0) {
    nBrand += brands.length - 1
    nBrand %= brands.length
    gotoBrand()
  }
})



document.querySelectorAll('.logo').forEach(logo => {
  logo.addEventListener('click', () => {

    nBrand = logo.dataset.value
    gotoBrand()
  })
})

document.querySelector(".overlay").addEventListener('click', () => {

  document.querySelector('.overlay').classList.add('off')
  document.querySelector('.control').classList.remove('off')
})


document.querySelector(".cta-intro").addEventListener('click', () => {

  document.querySelector('.intro').classList.add('off')

  setTimeout(()=>{
    document.querySelector('.overlay').classList.remove('off')
    document.querySelector('.brand-title').classList.remove('off')
  },500)



})
